/* ==========================================================================
   PHONE-ORDER RESTRICTIONS - Finescrubs
   --------------------------------------------------------------------------
   Two rules, both driven by COLLECTION MEMBERSHIP (never by the current URL):

     1. Every product in "kids-scrubs-and-lab-coats" is phone order only.
     2. In "100-cotton-scrubs-and-lab-coats", the NAVY colour variants are
        phone order only. Every other colour behaves normally.

   Kids wins if a product somehow qualifies for both.

   Restricted variants are genuinely prevented from reaching the cart. Every
   add-to-cart path the theme uses is guarded:

     - <form action="/cart/add"> submit  (capture phase, before the theme's
       own listener in assets/pdp.js runs)
     - HTMLFormElement.prototype.submit() called from script
     - clicks on add-to-cart buttons that are not real form submits
       (quick view uses type="button")
     - window.fetch to /cart/add or /cart/add.js  (assets/pdp.js)
     - XMLHttpRequest to /cart/add or /cart/add.js (jQuery / ajax-cart.js)
     - the dynamic checkout / express payment button, which would otherwise
       skip the cart entirely

   Server data comes from two Liquid snippets:
     snippets/phone-order-registry.liquid  - store-wide restricted variant IDs
     snippets/phone-order-notice.liquid    - the product page notice + data
   ========================================================================== */
(function () {
  'use strict';

  // Diagnostic marker: lets support confirm the guard is live on a page.
  window.PhoneOrderRestrictions = { loaded: true };

  var CART_ADD = /\/cart\/add(\.js)?($|\?)/;
  var KIDS = 'kids';

  /* ----------------------------------------------------------------- */
  /* Small helpers (kept dependency free)                               */
  /* ----------------------------------------------------------------- */
  function each(list, fn) {
    if (!list) return;
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }
  function qsa(sel, ctx) {
    return (ctx || document).querySelectorAll(sel);
  }
  function closestEl(node, sel) {
    while (node && node.nodeType === 1) {
      if (node.matches ? node.matches(sel) : false) return node;
      node = node.parentElement;
    }
    return null;
  }

  /* ----------------------------------------------------------------- */
  /* 1. Registry of restricted variant IDs                              */
  /* ----------------------------------------------------------------- */
  var registry = Object.create(null); // variant id (string) -> 'kids' | 'navy'

  function addIds(str, mode) {
    if (!str) return;
    var parts = String(str).split(',');
    for (var i = 0; i < parts.length; i++) {
      var id = parts[i].replace(/\s/g, '');
      if (id) registry[id] = mode || 'navy';
    }
  }

  function loadRegistry() {
    var el = document.getElementById('phone-order-registry');
    if (el) {
      try {
        var data = JSON.parse(el.textContent || el.innerHTML);
        addIds(data.kids, KIDS);
        addIds(data.navy, 'navy');
      } catch (e) { /* a malformed registry must never break the page */ }
    }
    each(qsa('[data-phone-order-root]'), function (root) {
      addIds(root.getAttribute('data-po-ids'), root.getAttribute('data-po-mode'));
    });
  }

  function restrictedMode(id) {
    if (id === null || id === undefined || id === '') return null;
    return registry[String(id).replace(/\s/g, '')] || null;
  }
  function isRestricted(id) { return !!restrictedMode(id); }

  /* ----------------------------------------------------------------- */
  /* 2. NAVY detection (mirrors the Liquid rule)                        */
  /*    "NAVY", "navy", "Navy", "NAVY - 820 - #000080",                 */
  /*    "NAVY-820-#000080"  -> navy                                     */
  /*    "NEW NAVY - 54 - #282099", "ROYAL", "BLACK", "BLUE" -> not navy */
  /* ----------------------------------------------------------------- */
  function isNavyValue(value) {
    if (!value) return false;
    var base = String(value).trim().split(/\s*-\s*/)[0].trim();
    return /^navy(\s|$)/i.test(base);
  }

  /* ----------------------------------------------------------------- */
  /* 3. Reading the variant a form is about to add                      */
  /* ----------------------------------------------------------------- */
  function formVariantId(form) {
    if (!form || !form.querySelector) return null;
    var el = form.querySelector('select[name="id"], input[name="id"]');
    return el ? el.value : null;
  }

  function formIsBlocked(form) {
    if (!form) return false;
    if (form.getAttribute('data-po-blocked') === 'true') return true;
    return isRestricted(formVariantId(form));
  }

  function idsInBody(body) {
    var out = [];
    try {
      if (!body) return out;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        out.push(body.get('id'));
      } else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        out.push(body.get('id'));
      } else if (typeof body === 'string') {
        if (body.charAt(0) === '{' || body.charAt(0) === '[') {
          var j = JSON.parse(body);
          if (j && j.id) out.push(j.id);
          if (j && j.items) each(j.items, function (it) { if (it && it.id) out.push(it.id); });
        } else if (typeof URLSearchParams !== 'undefined') {
          var p = new URLSearchParams(body);
          out.push(p.get('id'));
          each(p.getAll('items[][id]'), function (v) { out.push(v); });
        }
      }
    } catch (e) { /* unreadable body - fall through, other guards still apply */ }
    return out;
  }

  function bodyIsBlocked(body) {
    var ids = idsInBody(body);
    for (var i = 0; i < ids.length; i++) if (isRestricted(ids[i])) return true;
    return false;
  }

  /* ----------------------------------------------------------------- */
  /* 4. Product page state                                              */
  /* ----------------------------------------------------------------- */
  function productRoot() { return document.querySelector('[data-phone-order-root]'); }

  function productForms() {
    var forms = [];
    each(qsa('#AddToCartForm, #sticky-add-to-cart-form, form[action*="/cart/add"]'), function (f) {
      if (closestEl(f, '.enj-quickview, #quick-view, .quick-view, .CartContainer')) return;
      if (forms.indexOf(f) === -1) forms.push(f);
    });
    return forms;
  }

  function colourInput(index) {
    var swatch = document.querySelector('.swatch[data-option-index="' + index + '"]');
    if (swatch) {
      var checked = swatch.querySelector('input[type="radio"]:checked');
      if (checked) return checked;
      var sel = swatch.querySelector('select');
      if (sel) return sel;
    }
    return document.querySelector('select[name="option-' + index + '"]');
  }

  function productBlocked(root) {
    if (!root) return false;
    if (root.getAttribute('data-po-mode') === KIDS) return true;
    var ci = parseInt(root.getAttribute('data-po-color-index'), 10);
    if (!isNaN(ci) && ci > -1) {
      var input = colourInput(ci);
      // The colour control is the fastest, most reliable signal: it is correct
      // the instant the shopper clicks, before the theme swaps the variant id.
      if (input) return isNavyValue(input.value);
    }
    var form = document.getElementById('AddToCartForm') || productForms()[0];
    return isRestricted(formVariantId(form));
  }

  function setButtonBlocked(btn, blocked) {
    if (!btn) return;
    var label = btn.querySelector('span') || btn;
    if (blocked) {
      // Product-option apps re-render the button, so remember the original label
      // once and then keep re-applying ours if theirs comes back.
      if (btn.getAttribute('data-po-label') === null) {
        btn.setAttribute('data-po-label', label.textContent);
      }
      if (label.textContent.replace(/\s+/g, ' ').trim() !== 'Phone order only') {
        label.textContent = 'Phone order only';
      }
      if (!btn.disabled) { btn.setAttribute('data-po-disabled', 'true'); btn.disabled = true; }
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('phone-order-disabled');
    } else {
      var prev = btn.getAttribute('data-po-label');
      if (prev !== null) { label.textContent = prev; btn.removeAttribute('data-po-label'); }
      if (btn.getAttribute('data-po-disabled') === 'true') {
        btn.disabled = false;
        btn.removeAttribute('data-po-disabled');
      }
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('phone-order-disabled');
    }
  }

  function syncProductPage() {
    var root = productRoot();
    if (!root) return;
    var blocked = productBlocked(root);

    root.hidden = !blocked;

    each(productForms(), function (form) {
      if (blocked) form.setAttribute('data-po-blocked', 'true');
      else form.removeAttribute('data-po-blocked');
      each(form.querySelectorAll('button[type="submit"], input[type="submit"], [name="add"], .add-to-cart-change, .btn-add-stickycart'), function (btn) {
        setButtonBlocked(btn, blocked);
      });
    });

    // Dynamic checkout / express payment would skip the cart entirely.
    each(qsa('.pdp-buynow, .shopify-payment-button'), function (el) {
      el.classList.toggle('phone-order-hidden', blocked);
    });
  }

  /* Collection grids / search results: single-variant products render a real
     add-to-cart form, so mark the restricted ones up front too. */
  function syncListings() {
    each(qsa('form[action*="/cart/add"]'), function (form) {
      if (closestEl(form, '[data-phone-order-root]')) return;
      if (form.getAttribute('id') === 'AddToCartForm' || form.getAttribute('id') === 'sticky-add-to-cart-form') return;
      if (!isRestricted(formVariantId(form))) return;
      form.setAttribute('data-po-blocked', 'true');
      each(form.querySelectorAll('button, input[type="submit"]'), function (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('phone-order-disabled');
        btn.setAttribute('title', 'Phone order only - call (310) 208-7669 or (310) 985-4488');
      });
    });
  }

  function revealNotice() {
    var root = productRoot();
    if (!root || root.hidden) return;
    root.classList.add('phone-order-notice--flash');
    setTimeout(function () { root.classList.remove('phone-order-notice--flash'); }, 1200);
    if (root.scrollIntoView) root.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  /* ----------------------------------------------------------------- */
  /* 5. Hard blocks                                                     */
  /* ----------------------------------------------------------------- */

  // 5a. Form submit - capture phase, so it runs before the theme's own
  //     submit handler on the form itself and the request is never built.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!formIsBlocked(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    revealNotice();
  }, true);

  // 5b. Programmatic form.submit()
  if (window.HTMLFormElement && HTMLFormElement.prototype.submit) {
    var nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      var action = this.getAttribute ? (this.getAttribute('action') || '') : '';
      if (action.indexOf('/cart/add') !== -1 && formIsBlocked(this)) {
        revealNotice();
        return;
      }
      return nativeSubmit.apply(this, arguments);
    };
  }

  // 5c. Clicks on add-to-cart controls that are not real submits
  //     (quick view uses <button type="button"> + its own JS).
  document.addEventListener('click', function (e) {
    var btn = closestEl(e.target, 'button, a, input[type="submit"], input[type="button"]');
    if (!btn) return;
    var form = closestEl(btn, 'form');
    var inCartForm = !!(form && (form.getAttribute('action') || '').indexOf('/cart/add') !== -1);
    var isSubmit = (btn.getAttribute && btn.getAttribute('type') === 'submit') || btn.type === 'submit';
    // Only real add-to-cart controls. Size guide, quantity steppers and
    // "select options" links inside/near the form must keep working.
    var namedAtc = /(^|[\s"'])(btn-addToCart|add-to-cart-change|btn-add-stickycart|product-form__submit|enj-add-to-cart-btn)([\s"']|$)/i
      .test(' ' + (btn.className || '') + ' ');
    var isAtc = (inCartForm && isSubmit) || namedAtc;
    if (!isAtc) return;
    if (form ? !formIsBlocked(form) : !isRestricted(btn.getAttribute('data-variant-id'))) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    revealNotice();
  }, true);

  // 5d. fetch()
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_ADD.test(url)) {
          var body = (init && init.body) || null;
          if (bodyIsBlocked(body)) {
            revealNotice();
            return Promise.reject({
              status: 422,
              description: 'This item is phone order only. Call (310) 208-7669 or (310) 985-4488.'
            });
          }
        }
      } catch (e) { /* never break a normal request */ }
      return nativeFetch.apply(this, arguments);
    };
  }

  // 5e. XMLHttpRequest (jQuery, assets/ajax-cart.js, third parties)
  if (window.XMLHttpRequest && XMLHttpRequest.prototype) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__poUrl = url || '';
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (CART_ADD.test(this.__poUrl || '') && bodyIsBlocked(body)) {
          revealNotice();
          return; // request is never sent
        }
      } catch (e) { /* fall through */ }
      return nativeSend.apply(this, arguments);
    };
  }

  /* ----------------------------------------------------------------- */
  /* 6. Wiring                                                          */
  /* ----------------------------------------------------------------- */
  // Exposed for support/debugging and for QA of the navy rule.
  window.PhoneOrderRestrictions.isNavyValue = isNavyValue;
  window.PhoneOrderRestrictions.restrictedMode = restrictedMode;
  window.PhoneOrderRestrictions.registry = registry;

  function refresh() {
    loadRegistry();
    syncProductPage();
    syncListings();
  }

  function scheduleSync() {
    // The theme swaps the variant id after its own change handlers run, so
    // re-read on the next tick as well as immediately.
    syncProductPage();
    setTimeout(syncProductPage, 0);
    setTimeout(syncProductPage, 150);
  }

  document.addEventListener('change', scheduleSync, true);
  document.addEventListener('click', function (e) {
    if (closestEl(e.target, '.swatch, .pdp-selector, [data-option-index]')) scheduleSync();
  }, true);
  window.addEventListener('popstate', scheduleSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  window.addEventListener('load', refresh);

  // Product-option apps replace the add-to-cart button after load, so re-apply
  // the blocked state a few times over the first seconds of the page.
  var settleTicks = 0;
  var settle = setInterval(function () {
    settleTicks++;
    syncProductPage();
    syncListings();
    if (settleTicks > 12) clearInterval(settle);
  }, 500);

  // Quick view and infinite scroll inject markup after load.
  if (window.MutationObserver) {
    // Quick view, infinite scroll and app widgets inject markup after load.
    // Only re-scan when the number of add-to-cart forms actually changes, so
    // our own class toggles can never feed the observer back into itself.
    var lastFormCount = qsa('form[action*="/cart/add"]').length;
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        var n = qsa('form[action*="/cart/add"]').length;
        if (n !== lastFormCount) { lastFormCount = n; refresh(); }
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
